<app-spinner-overlay></app-spinner-overlay>

<div class="titolo-pagina" style="padding-top: 20px">
  <div class="titolo-diag">{{ titolo }}</div>
</div>
@if (data.folder) {
  <app-breadcrumb-folder-tree
    [listaFolders]="data.listaFolders"
    [isDialogCreazione]="data.isCreazione ?? false"
    [lastFolderDynamic]="form.get('name')?.value"
    [useInDialog]="true"
    [folderSelezionato]="data.folder"
  ></app-breadcrumb-folder-tree>
}
<div style="height: 30px"></div>
<form [formGroup]="form" appFormContainer [larghezza]="1" [gap]="10" [rowGap]="5">
  <mat-form-field appFormElement [larghezza]="3" [riempi]="true" appearance="outline">
    <mat-label>Nome {{ data.folder ? 'Cartella' : 'Documento' }}</mat-label>
    <input
      #nameInput
      matInput
      [placeholder]="'Nome' + data.folder ? 'Cartella' : 'Documento'"
      formControlName="name"
      (blur)="updateErrorMessage()"
    />
    @if (errorMessage()) {
      <mat-hint style="color: #f44336">{{ errorMessage() }}</mat-hint>
    }
    @if (data.file) {
      <span matTextSuffix>.{{ data.file.extension }}</span>
    }
  </mat-form-field>
</form>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Indietro</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Conferma
    </button>
  </div>
</div>
